/* Use Shopify's existing cart; never replace it with a single-cake permalink. */
(function () {
  'use strict';
  function create(root, request, makeId) {
    const attempts = new Map();
    async function json(path, options) {
      const response = await request(root + path, Object.assign({credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}}, options));
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'We could not update your cart. Please try again.');
      return result;
    }
    const read = () => json('cart.js');
    async function add(variantId, properties) {
      const signature = JSON.stringify([variantId, properties]);
      let attempt = attempts.get(signature);
      if (!attempt) { attempt = {id:makeId(),pending:false}; attempts.set(signature, attempt); }
      let cart = await read();
      if (cart.items.some(item => item.properties && item.properties._cc_configuration === attempt.id)) return cart;
      // A disconnected response may still have added the cake. Don't blindly repeat it.
      if (attempt.pending) throw new Error('We could not confirm the last addition. Please open your cart and check before adding this cake again.');
      attempt.pending = true;
      let response;
      try {
        response = await request(root + 'cart/add.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:1,properties:Object.assign({},properties,{_cc_configuration:attempt.id})}]})});
      } catch (_) { throw new Error('Connection interrupted. Please open your cart to check whether your cake was added.'); }
      if (!response.ok) {
        // Shopify can partially satisfy an inventory-limited add; reconcile before retry.
        cart = await read();
        if (cart.items.some(item => item.properties && item.properties._cc_configuration === attempt.id)) {attempt.pending=false;return cart;}
        if (response.status >= 400 && response.status < 500) attempt.pending=false;
        const result=await response.json();
        throw new Error(result.description || result.message || 'Could not add this cake. Please check your cart.');
      }
      // Keep pending until the read confirms the mutation, including a lost read response.
      cart = await read();
      if (!cart.items.some(item => item.properties && item.properties._cc_configuration === attempt.id)) throw new Error('Your cart is still updating. Please open your cart to check your cake.');
      attempt.pending=false;
      return cart;
    }
    return {add,read};
  }
  if (typeof module !== 'undefined' && module.exports) module.exports={create};
  if (typeof window !== 'undefined') window.CCCartActions={create};
})();
